var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-icon",class:_vm.dotted ? 'vb-icon--dotted' : '',style:(`--size:${_vm.size}px; --color: ${_vm.color_ui.includes('--') ? 'var('+_vm.color_ui+')' : ('#'+_vm.color_ui.replace('#', ''))}`),domProps:{"innerHTML":_vm._s(_vm.Icons[_vm.name.replace('-','_')])},on:{"click":$event => {
    if (this.$listeners.click) this.$listeners.click($event)
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }